export const USER_SIGNIN = 'USER_SIGNIN' //登录成功
export const USER_SIGNOUT = 'USER_SIGNOUT' //退出登录
export const UPDATE_TOKEN = 'UPDATE_TOKEN' //TOKEN
export const UPDATE_MAC = 'UPDATE_MAC' //用户班级
export const USER_CLASS = 'USER_CLASS' //用户班级
export const USER_ROLE = 'USER_ROLE' //用户角色
export default {
    state: {
    	userinfo: JSON.parse(sessionStorage.getItem('user')),
    	token:sessionStorage.getItem('token'),
        userclass:JSON.parse(sessionStorage.getItem('classinfo')),
        rolecode:sessionStorage.getItem('rolecode'),
    },
	mutations: {
		[USER_SIGNIN](state, user) {
    //   if(user.phaseCode){
    //     let pharseArr = user.phaseCode.split(",");
    //     let index = pharseArr.indexOf("05");
    //     if (index > -1) {
    //       pharseArr.splice(index, 1);
    //     }
    //     user.phaseCode = pharseArr.join(",");
    //   }
			sessionStorage.setItem('user', JSON.stringify(user));
			state.userinfo = user
		},
		[USER_SIGNOUT](state) {
			sessionStorage.removeItem('user');
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('classinfo');
            sessionStorage.removeItem('mac');
            sessionStorage.removeItem('tgt');
            sessionStorage.removeItem('rolecode');
		},
		[UPDATE_TOKEN](state, token) {
			sessionStorage.setItem('token', token);
			state.token = token
		},
        [UPDATE_MAC](state, mac) {
            sessionStorage.setItem('mac', mac);
            state.mac = mac
        },
        [USER_CLASS](state, classinfo) {
            sessionStorage.setItem('classinfo', JSON.stringify(classinfo));
            state.userclass = classinfo
        },
        [USER_ROLE](state, rolecode) {
            sessionStorage.setItem('rolecode',rolecode);
            state.rolecode = rolecode
        },
	},
    actions: {
        [USER_SIGNIN]({commit}, user) {
            commit(USER_SIGNIN, user)
        },
        [USER_SIGNOUT]({commit}) {
            commit(USER_SIGNOUT)
        },
        [UPDATE_TOKEN]({commit}) {
            commit(UPDATE_TOKEN)
        },
        [UPDATE_MAC]({commit}) {
            commit(UPDATE_MAC)
        },
        [USER_CLASS]({commit}) {
            commit(USER_CLASS)
        },
        [USER_ROLE]({commit}) {
            commit(USER_ROLE)
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/user.js